import React from 'react';
import styles from './Pagination.module.css';

export default function Pagination({ page, pages, onPage }) {
  if (pages <= 1) return null;

  return (
    <div className={styles.wrap}>
      <button
        className={styles.btn}
        disabled={page === 1}
        onClick={() => onPage(page - 1)}
      >
        ← Prev
      </button>
      <span className={styles.info}>
        Page {page} of {pages}
      </span>
      <button
        className={styles.btn}
        disabled={page === pages}
        onClick={() => onPage(page + 1)}
      >
        Next →
      </button>
    </div>
  );
}
